export default "__VITE_ASSET__BsrJuGAJ__"